import { render } from "./App.vue?vue&type=template&id=04c424de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=04c424de&lang=css"

import exportComponent from "/home/runner/work/ncalendar/ncalendar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__